import React, { useEffect, useRef, useState } from "react";
import "../../styles/home.css";

import anahita from "../../assets/images/logo/anahita.jpg";
import deloitte from "../../assets/images/logo/Deloitte.jpg";
import fatLulu from "../../assets/images/logo/fat LuLu.jpg";
import google from "../../assets/images/logo/google.jpg";
import image from "../../assets/images/logo/image.jpg";
import images from "../../assets/images/logo/images.jpg";
import kingfisher from "../../assets/images/logo/kingfisher.jpg";
import somo from "../../assets/images/logo/somo.jpg";
import barista from '../../assets/images/logo/Barista.jpg';
import dhaba from '../../assets/images/logo/Dhaba by Claridges - Sudakshina joshi.jpg';
import onecommune from '../../assets/images/logo/onecommune.jpg';
import bohosvilla from '../../assets/images/logo/Bohosvilla.jpg';

const clients = [
  { name: "Anahita", logo: anahita },
  { name: "Deloitte", logo: deloitte },
  { name: "Fat LuLu", logo: fatLulu },
  { name: "Google", logo: google },
  { name: "Client", logo: image },
  { name: "Client", logo: images },
  { name: "Kingfisher", logo: kingfisher },
  { name: "Somo", logo: somo },
  { name: "Barista", logo: barista },
  { name: "Dhaba", logo: dhaba },
  { name: "One Commune", logo: onecommune },
];

// Each strip's vertical offset, so the row reads as a loose collage.
const OFFSETS = [0, 18, 6, 28, -8, 14, 32, 2, 22, -4, 12];

// A row of tall strips that builds itself left to right, each sliding out
// from behind the one before; hovering a strip enlarges it a little.
const OurClients = () => {
  const rowRef = useRef(null);
  const [shown, setShown] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        setShown(true);
        observer.disconnect();
      },
      { threshold: 0.3 }
    );
    observer.observe(rowRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="clients-section">
      <div className="clients-inner">
        <h3 className="section-heading">
          Our <span className="section-heading-accent">Clients</span>
        </h3>

        <span className="clients-rule is-active" aria-hidden="true" />

        <div className={`clients-row${shown ? " is-shown" : ""}`} ref={rowRef}>
          {clients.map((client, i) => (
            <div
              className="clients-strip"
              key={`${client.name}-${i}`}
              style={{ "--y": `${OFFSETS[i % OFFSETS.length]}px`, zIndex: clients.length - i, transitionDelay: `${i * 0.07}s` }}
            >
              {/* The image sits whole; a blurred copy of it fills the rest of the strip. */}
              <div className="clients-card" style={{ "--img": `url("${client.logo}")` }}>
                <img src={client.logo} alt={client.name} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurClients;
